import React from 'react';
import LocationTemplate from './LocationTemplate';

const MorrisvillePage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Morrisville"
      stateName="North Carolina"
      countyName="Wake"
      zipCodes={["27560"]}
      latitude={35.8232}
      longitude={-78.8256}
      population={31278}
      historicalFact="Originally called Morrisville Station, an important railroad depot during the Civil War."
      nearbyTowns={[
        "Cary, NC",
        "Raleigh, NC",
        "Durham, NC",
        "Chapel Hill, NC",
        "Apex, NC",
        "Holly Springs, NC",
        "Research Triangle Park, NC",
        "Wake Forest, NC"
      ]}
    />
  );
};

export default MorrisvillePage;